/**
 * Scroll suave a un elemento por id. Reemplaza a los anchors `href="#id"`, que
 * solo scrollean UNA vez: si el hash ya está en la URL, el navegador no vuelve a
 * hacer scroll. Este helper re-dispara en cada llamada.
 *
 * El offset del navbar fijo lo da `scroll-margin-top` en el elemento destino
 * (usar `scrollMarginTop: 'var(--nav-h)'` para que su borde tope con el topbar).
 *
 * Uso:
 *   import { scrollToId } from '@/libs/scroll';
 *   <button onClick={() => scrollToId('contenido')}>…</button>
 *   // o desde un anchor, preservando la URL compartible:
 *   <a href="#form" onClick={(e) => scrollToId('form', e)}>…</a>
 */
export function scrollToId(id, event) {
  if (event) event.preventDefault();
  if (typeof document === 'undefined') return;
  const target = id === '' || id === '#' ? null : id.replace(/^#/, '');
  if (!target) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }
  document
    .getElementById(target)
    ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
